// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Ficha de servidor · variante «tarjetas» (beta).
 *
 * Todo va prefijado con \`sf2-\` a propósito: la ficha clásica no debe cambiar
 * ni un píxel mientras la beta está detrás del flag. No se reutilizan clases
 * estructurales de DetailView (\`.dv-body\`, \`.dv-main\`, \`.dv-sidebar\`) salvo
 * las de los paneles que se montan tal cual.
 */

/* ── Cabecera fija ────────────────────────────────────────────────────────
   En la variante tarjetas el scroll NO lo hace \`.dv-main\`: el formulario se
   queda quieto y scrollea solo \`.sf2-scroll\`. Así la cabecera y las pestañas
   son hermanas del área desplazable y es materialmente imposible que algo se
   vea por detrás (nada de sticky, nada de trucos de márgenes). */
.dv-main.sf2-main {
  padding: 0;
  gap: 0;
  overflow: hidden;
}

.sf2-headarea {
  position: relative;
  z-index: 5;
  flex: none;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  /* Sin padding inferior: el borde de las pestañas hace de separador con la
     zona que sí se desplaza. */
  padding: 1.1rem 2rem 0;
  background: var(--slate-50);
}

/* En fichas con \`<fieldset class="dv-fieldset">\` (VM), el fieldset hace de
   contenedor principal: tiene que repartir altura como haría \`.dv-main\`. */
.dv-fieldset.sf2-main {
  flex: 1 1;
  min-height: 0;
  padding: 0;
  gap: 0;
  overflow: hidden;
}

/* ── Selector de ubicación en árbol (LocationTreeSelect) ──────────────── */
.sf2-locsel { position: relative; width: 100%; }

.sf2-locsel-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 9px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--slate-50);
  color: var(--text-primary);
  font: inherit;
  font-size: 0.84rem;
  text-align: left;
  cursor: pointer;
}

.sf2-locsel-trigger:hover { border-color: var(--accent); }
.sf2-locsel-trigger:disabled { opacity: 0.6; cursor: default; border-color: var(--border); }

.sf2-locsel-value {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sf2-locsel-value--empty { color: var(--text-muted); }
.sf2-locsel-caret { width: 14px; height: 14px; flex: none; color: var(--text-muted); }

.sf2-locsel-pop {
  position: absolute;
  z-index: 60;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 320px;
  overflow-y: auto;
  padding: 4px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.2);
}

/* Variante fija: se mide desde el botón para que no la recorte el scroll del panel */
.sf2-locsel-pop--fixed {
  position: fixed;
  z-index: 3000;
  top: auto;
  right: auto;
  bottom: auto;
}

.sf2-locsel-row {
  display: flex;
  align-items: center;
  gap: 7px;
  width: 100%;
  padding: 5px 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--text-primary);
  font: inherit;
  font-size: 0.82rem;
  text-align: left;
  cursor: pointer;
}

.sf2-locsel-row:hover { background: var(--slate-100); }
.sf2-locsel-row--sel { background: rgba(var(--accent-rgb), 0.12); color: var(--accent-l, var(--accent)); font-weight: 600; }
.sf2-locsel-icon { flex: none; font-size: 0.85rem; }
.sf2-locsel-name { flex: 1 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.sf2-locsel-type { flex: none; font-size: 0.7rem; color: var(--text-muted); font-weight: 400; }
.sf2-locsel-empty { padding: 8px 10px; color: var(--text-muted); font-size: 0.8rem; }

/* ── Organigrama de ubicaciones ───────────────────────────────────────── */
.sf2-grid > .dv-section { margin-bottom: 0; }

.sf2-orgcaption {
  font-size: 0.74rem;
  color: var(--text-muted);
  margin-bottom: 8px;
}

.sf2-orgcaption b { color: var(--text-secondary); font-weight: 600; }

.sf2-orgtree,
.sf2-orgchildren {
  list-style: none;
  margin: 0;
  padding: 0;
}

.sf2-orgchildren {
  margin-left: 14px;
  padding-left: 14px;
  border-left: 1px dashed var(--border);
}

.sf2-orgnode { margin: 4px 0; }

.sf2-orgrow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 8px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--bg-card);
}

.sf2-orgrow--current {
  border-color: var(--accent);
  background: rgba(var(--accent-rgb), 0.08);
}

.sf2-orgrow--off { opacity: 0.55; }
.sf2-orgicon { flex: none; font-size: 0.95rem; }

.sf2-orgname {
  flex: 1 1;
  min-width: 0;
  display: grid;
  gap: 1px;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 0;
  font: inherit;
  font-size: 0.86rem;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
}

.sf2-orgname small {
  font-size: 0.7rem;
  font-weight: 400;
  color: var(--text-muted);
}

.sf2-orgname:hover { color: var(--accent-l, var(--accent)); }

.sf2-orgadd {
  flex: none;
  display: inline-grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-secondary);
  cursor: pointer;
}

.sf2-orgadd svg { width: 14px; height: 14px; }
.sf2-orgadd:hover { border-color: var(--accent); color: var(--accent); }

.sf2-scroll {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  /* Sin padding superior: \`.dv-tab-pane\` ya aporta 1.25rem bajo la línea de
     pestañas. Así el contenido arranca pegado y se gana pantalla. */
  padding: 0 2rem 1.5rem;
}

/* En la ficha clásica los envoltorios no deben existir: los hijos vuelven a ser
   items directos del formulario y conservan el \`gap\` de \`.dv-main\`. */
.sf2-plain { display: contents; }

/* ── Cabecera ─────────────────────────────────────────────────────────── */
.sf2-head {
  display: flex;
  gap: 12px;
  /* El icono se alinea con la línea del título, no con el centro del bloque
     (que incluye la migaja y queda descuadrado). */
  align-items: flex-start;
  flex-wrap: wrap;
}

.sf2-head-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--slate-100);
  border: 1px solid var(--border);
  display: grid;
  place-items: center;
  color: var(--accent);
  flex: none;
  /* El título arranca un pelo por debajo del borde del icono: así las dos
     primeras líneas quedan ópticamente alineadas sin tocar la tipografía. */
  margin-top: 1px;
}

.sf2-head-title { flex: 1 1; min-width: 200px; }

/* Interruptores de estado dentro de una tarjeta de campos (Identificación). */
.sf2-field-switches { display: flex; align-items: center; gap: 18px; flex-wrap: wrap; }

.sf2-head-title h1 {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.2;
  letter-spacing: -0.01em;
}

.sf2-title-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }

/* Título editable de una ficha con patrón *inline edit*:
 *
 *   · En reposo se ve como el h1 de una ficha de solo lectura: sin caja, con
 *     la tipografía del título y el ancho justo del texto.
 *   · Al pasar el ratón aparece un borde tenue y el lápiz de la derecha.
 *   · Al enfocar (clic o tabulador) se marca con el color primario, fondo de
 *     campo y anillo de foco, sin mover nada de sitio (el borde es interior y
 *     el padding se compensa con margen negativo).
 */
.sf2-head-input {
  /* El ancho sigue al texto. \`field-sizing\` lo resuelve solo en Chrome/Edge
     recientes; el respaldo calcula con el número de caracteres que publica el
     componente en \`--sf2-title-len\`. */
  field-sizing: content;
  min-width: 8ch;
  max-width: min(60ch, 100%);
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  padding: 2px 6px;
  margin: -2px -6px;
  outline: none;
  font: inherit;
  font-size: 1.6rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--text-primary);
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}

@supports not (field-sizing: content) {
  .sf2-head-input {
    width: calc(var(--sf2-title-len, 12) * 0.56em + 1em);
  }
}

.sf2-head-input::placeholder { color: var(--text-muted); font-weight: 600; }

/* En modo lectura el título NO se pinta como un campo: al pasar el ratón solo
 * aparece el lápiz, sin borde ni fondo. El marco llega con el foco, que es
 * cuando de verdad se está editando. */
.sf2-head-input:focus {
  border-color: var(--accent);
  background: var(--bg-input);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.18);
}

/* El lápiz solo se ve cuando se apunta al título (o con el foco dentro), que es
   lo que anuncia que el nombre se puede editar. Sin caja: es una pista, no un
   botón de modo. Se anula la caja de \`.sf2-title-btn\`, que sí la necesitan ✓/✕. */
.sf2-title-btn.sf2-title-pencil {
  opacity: 0;
  border-color: transparent;
  background: transparent;
  transition: opacity 0.15s ease;
}

.sf2-title-btn.sf2-title-pencil:hover {
  border-color: var(--border);
  color: var(--accent-l, var(--accent));
}

.sf2-title-row:hover .sf2-title-pencil,
.sf2-title-row:focus-within .sf2-title-pencil,
.sf2-title-pencil:focus-visible {
  opacity: 1;
}

.sf2-head-chips { margin-top: 6px; }

/* \`.dv-tabs-nav\` tiene \`overflow-x: auto\`, lo que en Chrome activa también el
   eje vertical y saca una barra de scroll inútil junto a las pestañas. */
.sf2-headarea .dv-tabs-nav { overflow-y: hidden; }

.sf2-title-btn {
  display: inline-grid;
  place-items: center;
  width: 30px;
  height: 30px;
  flex: none;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-secondary);
  cursor: pointer;
}

.sf2-title-btn svg { width: 16px; height: 16px; }
.sf2-title-btn:hover { border-color: var(--accent); color: var(--accent-l, var(--accent)); }
.sf2-title-btn:disabled { opacity: 0.5; cursor: default; }
.sf2-title-btn--ok { border-color: rgba(34, 197, 94, 0.45); color: #16a34a; }
.sf2-title-btn--ok:hover { border-color: #16a34a; color: #16a34a; }

.sf2-crumb {
  font-size: 0.78rem;
  color: var(--text-muted);
  margin-top: 0;
  overflow-wrap: anywhere;
}

.sf2-crumb b { color: var(--text-secondary); font-weight: 600; }

.sf2-badges { display: flex; gap: 6px; flex-wrap: wrap; }

.sf2-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  background: var(--slate-100);
  border: 1px solid var(--border);
  color: var(--text-secondary);
  white-space: nowrap;
}

.sf2-badge i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--c, #22c55e);
  flex: none;
}

/* ── Chips de relaciones ──────────────────────────────────────────────── */
.sf2-chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
}

.sf2-chip {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 5px 11px;
  border-radius: 8px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  cursor: pointer;
  color: var(--text-secondary);
  font: inherit;
  transition: border-color 0.15s, background 0.15s;
}

.sf2-chip:hover { border-color: var(--accent); }
.sf2-chip:disabled { opacity: 0.55; cursor: default; border-color: var(--border); }
.sf2-chip b { font-size: 1rem; color: var(--text-primary); line-height: 1; }
.sf2-chip span { font-size: 0.8rem; color: var(--text-muted); }
.sf2-chip.sf2-chip--flat { background: transparent; border-style: dashed; cursor: default; }
.sf2-chip.sf2-chip--flat:hover { border-color: var(--border); }

/* ── Pestañas con menú «Más» ──────────────────────────────────────────── */
.sf2-tabs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
  border-bottom: 2px solid var(--border);
  position: relative;
}

.sf2-more { position: relative; margin-left: auto; flex: none; }

.sf2-more-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0.55rem 0.9rem;
  border: 0;
  background: transparent;
  color: var(--text-muted);
  font: inherit;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  white-space: nowrap;
}

.sf2-more-btn:hover { color: var(--text-primary); }
.sf2-more-btn[aria-expanded="true"] { color: var(--accent-l, var(--accent)); border-bottom-color: var(--accent); }

.sf2-more-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  min-width: 230px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 4px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
  z-index: 30;
}

.sf2-more-menu button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-secondary);
  font: inherit;
  font-size: 0.84rem;
  text-align: left;
  cursor: pointer;
}

.sf2-more-menu button:hover { background: var(--slate-100); color: var(--text-primary); }
.sf2-more-menu button[aria-current="true"] { color: var(--accent-l, var(--accent)); font-weight: 600; }
.sf2-more-menu em { font-style: normal; font-size: 0.72rem; color: var(--text-muted); }

/* ── Resumen: tarjetas y campos ───────────────────────────────────────── */
.sf2-summary { display: grid; gap: 16px; }

.sf2-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  align-items: start;
}

/* Dos columnas fijas: en fichas anchas \`auto-fit\` reparte en 3-4 columnas y
   las tarjetas quedan estrechas. Es el patrón del Resumen de servidor. */
.sf2-grid--2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

/* Con dos columnas y poco ancho (panel lateral abierto en portátil) los campos
   quedan a 50 px. Mientras siga habiendo dos columnas, los campos pasan a uno. */
@media (min-width: 901px) and (max-width: 1280px) {
  .sf2-grid--2 .sf2-fields { grid-template-columns: minmax(0, 1fr); }
}

@media (max-width: 900px) {
  .sf2-grid--2 { grid-template-columns: 1fr; }
}

.sf2-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg, 10px);
  padding: 16px;
  min-width: 0;
}

.sf2-card h3 {
  margin: 0 0 12px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.sf2-card h3 a,
.sf2-card h3 button.sf2-link {
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  font-size: 0.76rem;
  font-weight: 500;
  color: var(--text-muted);
  cursor: pointer;
}

.sf2-link {
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  color: var(--accent-l, var(--accent));
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
  text-align: left;
}

.sf2-link:hover { filter: brightness(1.12); }
.sf2-hint .sf2-link { font-size: inherit; font-weight: 600; white-space: nowrap; }

.sf2-card h3 a:hover,
.sf2-card h3 button.sf2-link:hover { color: var(--accent-l, var(--accent)); text-decoration: underline; }

.sf2-fields {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(var(--n, 2), minmax(0, 1fr));
}

.sf2-field { min-width: 0; }

.sf2-field label {
  display: block;
  font-size: 0.72rem;
  color: var(--text-muted);
  margin-bottom: 3px;
}

.sf2-field .v {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 26px;
  font-size: 0.86rem;
  font-weight: 500;
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

.sf2-field .v.sf2-muted { color: var(--text-muted); font-weight: 400; }

.sf2-field input,
.sf2-field select,
.sf2-field textarea {
  width: 100%;
  background: var(--slate-50);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 6px 9px;
  font: inherit;
  font-size: 0.84rem;
  color: var(--text-primary);
}

.sf2-field textarea { resize: vertical; min-height: 64px; }

.sf2-field input:focus,
.sf2-field select:focus,
.sf2-field textarea:focus {
  border-color: var(--accent);
  outline: none;
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.18);
}

.sf2-hint { font-size: 0.72rem; color: var(--text-muted); margin-top: 4px; display: block; }

/* Campo con una acción pegada al lado (Código + generar en el rack). */
.sf2-input-row { display: flex; gap: 6px; align-items: stretch; }
.sf2-input-row > input { flex: 1 1 auto; min-width: 0; }

/* Campo compacto dentro de una tabla: edición EN LA LÍNEA (registros DNS). */
.sf2-cell-input {
  width: 100%;
  min-width: 0;
  padding: 4px 6px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--bg-input, var(--bg-toolbar));
  color: var(--text-primary);
  font-size: 0.78rem;
  font-family: inherit;
}

.sf2-cell-input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.15);
}

.sf2-icon-btn {
  flex: none;
  width: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: var(--slate-50);
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--accent);
  cursor: pointer;
}

.sf2-icon-btn:hover:not(:disabled) {
  border-color: var(--accent);
  background: rgba(var(--accent-rgb), 0.10);
}

.sf2-icon-btn:disabled { opacity: 0.5; cursor: default; }

/* Dos tarjetas apiladas ocupando una sola columna del grid. */
.sf2-col-stack { display: grid; gap: 16px; align-content: start; min-width: 0; }

/* ── Salud ────────────────────────────────────────────────────────────── */
.sf2-hl {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 10px;
}

.sf2-kpi {
  background: var(--slate-100);
  border-radius: 9px;
  padding: 10px 12px;
  min-width: 0;
}

.sf2-kpi > span { font-size: 0.72rem; color: var(--text-muted); }
.sf2-kpi > b { display: block; font-size: 1.2rem; color: var(--text-primary); line-height: 1.2; }
.sf2-kpi small { font-size: 0.7rem; color: var(--text-muted); }

/* ── Ocupación (bloque unificado) ──────────────────────────────────────
 * Un solo bloque en lugar de las cinco tarjetas de KPIs: cifra grande arriba,
 * barra segmentada (un segmento por U) y leyenda debajo. Los segmentos usan el
 * acento del tema para lo ocupado y \`--slate-300\` para lo libre, que existe en
 * las 12 paletas (claro y oscuro).
 */
.sf2-occ {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.sf2-occ-top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px 16px;
  flex-wrap: wrap;
}

.sf2-occ-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.25;
}

.sf2-occ-pct {
  font-size: 0.8rem;
  color: var(--text-muted);
  white-space: nowrap;
}

.sf2-occ-bar {
  display: flex;
  gap: 2px;
  height: 14px;
  width: 100%;
}

.sf2-occ-seg {
  flex: 1 1;
  min-width: 0;
  border-radius: 2px;
  background: var(--slate-300);
}

.sf2-occ-seg.is-on {
  background: var(--accent);
}

/* Racks muy altos (>60U): una barra continua, que 90 segmentos no se leen. */
.sf2-occ-track {
  height: 14px;
  width: 100%;
  border-radius: 2px;
  background: var(--slate-300);
  overflow: hidden;
}

.sf2-occ-fill {
  display: block;
  height: 100%;
  border-radius: 2px;
  background: var(--accent);
  transition: width 0.2s ease;
}

.sf2-occ-legend {
  display: flex;
  align-items: center;
  gap: 6px 16px;
  flex-wrap: wrap;
  font-size: 0.78rem;
  color: var(--text-secondary);
}

.sf2-occ-legend b {
  color: var(--text-primary);
  font-weight: 700;
}

.sf2-occ-legend .sf2-link {
  margin-left: auto;
}

@media (max-width: 640px) {
  .sf2-occ-title { font-size: 1.02rem; }
  .sf2-occ-legend .sf2-link { margin-left: 0; }
}

.sf2-spark { width: 100%; height: 28px; display: block; margin-top: 4px; }

.sf2-alert {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 9px 14px;
  border-radius: 9px;
  background: rgba(245, 158, 11, 0.12);
  border: 1px solid rgba(245, 158, 11, 0.42);
  color: var(--text-primary);
  font-size: 0.84rem;
}

.sf2-alert-list { display: grid; gap: 2px; }

.sf2-alert-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 7px 2px;
  border-bottom: 1px solid var(--border);
  font-size: 0.84rem;
  color: var(--text-secondary);
}

.sf2-alert-row:last-child { border-bottom: 0; }
.sf2-alert-row span:last-child { color: var(--text-muted); white-space: nowrap; }

/* ── Completitud ──────────────────────────────────────────────────────── */
.sf2-bar {
  height: 6px;
  background: var(--slate-200);
  border-radius: 9px;
  overflow: hidden;
}

.sf2-bar i { display: block; height: 100%; background: var(--accent); transition: width 0.3s; }

/* ── Dock de cambios sin guardar ──────────────────────────────────────── */
.sf2-dock {
  position: sticky;
  bottom: 12px;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  background: var(--slate-100);
  border: 1px solid var(--accent);
  border-radius: 12px;
  padding: 10px 14px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  font-size: 0.84rem;
  color: var(--text-primary);
  z-index: 20;
}

/* ── Responsive ───────────────────────────────────────────────────────── */
@media (max-width: 900px) {
  .sf2-fields { --n: 2; }
}

@media (max-width: 768px) {
  /* Cabecera y contenido con el aire de una pantalla de dedo. */
  .sf2-headarea { padding: 0.9rem 1rem 0; gap: 0.5rem; }
  .sf2-scroll { padding: 0 1rem 1rem; }
  .sf2-head { gap: 9px; }
  .sf2-head-title { min-width: 0; flex: 1 1; }
  .sf2-head-input { font-size: 1.25rem; max-width: 100%; }
  .sf2-head-icon { width: 34px; height: 34px; }

  /* Los badges (Activo · Producción · Sin agente) medían 282 px y dejaban el
     título en una columna de 24 px: una letra por línea. Bajan a su fila. */
  .sf2-badges {
    order: 9;
    flex: 1 1 100%;
  }

  /* Ocho pestañas en tres filas ocupaban 116 px: en una sola fila con scroll. */
  .sf2-tabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
  }

  .sf2-tabs::-webkit-scrollbar { display: none; }
  .sf2-tabs > * { flex-shrink: 0; }

  .sf2-dock {
    bottom: 8px;
    padding: 9px 12px;
  }
}

@media (max-width: 560px) {
  .sf2-fields { --n: 1; }
  .sf2-head-title h1 { font-size: 1.2rem; }
  .sf2-dock > * { flex: 1 1 100%; }
  .sf2-dock button { width: 100%; justify-content: center; }
}

/* ── Listados dentro de tarjetas ──────────────────────────────────────── */
.sf2-rows { display: grid; gap: 0; }

.sf2-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 9px 2px;
  border-bottom: 1px solid var(--border);
}

.sf2-row:last-child { border-bottom: 0; }
.sf2-row-main { min-width: 0; }
.sf2-row-main b { display: block; font-size: 0.86rem; color: var(--text-primary); font-weight: 600; }
.sf2-row-main small { display: block; font-size: 0.75rem; color: var(--text-muted); margin-top: 2px; overflow-wrap: anywhere; }

.sf2-count {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--text-muted);
  background: var(--slate-100);
  border-radius: 999px;
  padding: 1px 8px;
}

.sf2-pill {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  background: var(--slate-100);
  border: 1px solid var(--border);
  color: var(--text-muted);
  white-space: nowrap;
}

.sf2-pill--ok { color: var(--text-primary); border-color: rgba(34, 197, 94, 0.45); background: rgba(34, 197, 94, 0.16); }
.sf2-pill--bad { color: var(--text-primary); border-color: rgba(239, 68, 68, 0.5); background: rgba(239, 68, 68, 0.18); }
.sf2-pill--ac { color: var(--text-primary); border-color: rgba(99, 102, 241, 0.45); background: rgba(99, 102, 241, 0.14); }
.sf2-pill--wa { color: var(--text-primary); border-color: rgba(245, 158, 11, 0.5); background: rgba(245, 158, 11, 0.16); }
.sf2-pill--info { color: var(--text-primary); border-color: rgba(14, 165, 233, 0.45); background: rgba(14, 165, 233, 0.14); }
.sf2-pill--vi { color: var(--text-primary); border-color: rgba(139, 92, 246, 0.45); background: rgba(139, 92, 246, 0.14); }

/* ── IPs asignadas ──────────────────────────────────────────────────── */
.sf2-ip-table th:first-child,
.sf2-ip-table td:first-child { width: 24px; }
.sf2-ip-star { text-align: center; color: var(--accent-l, var(--accent)); font-size: 0.9rem; }
.sf2-ip-addr {
  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);
  font-weight: 700;
  color: var(--text-primary);
}
.sf2-ip-table tr.sf2-ip-primary td { background: rgba(var(--accent-rgb), 0.07); }

.sf2-ip-manage {
  margin-top: 14px;
  padding-top: 10px;
  border-top: 1px solid var(--border);
}

.sf2-ip-manage > summary {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  list-style: none;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--accent-l, var(--accent));
}

.sf2-ip-manage > summary::-webkit-details-marker { display: none; }
.sf2-ip-manage > summary::before { content: '▸'; color: var(--text-muted); }
.sf2-ip-manage[open] > summary::before { content: '▾'; }
.sf2-ip-manage[open] > summary { margin-bottom: 12px; }

/* ── Gestor de IPs (sustituye al panel antiguo) ─────────────────────── */
.sf2-ip-manager { display: grid; gap: 14px; }
.sf2-ip-form { display: grid; gap: 12px; }
.sf2-ip-input-row { display: flex; gap: 8px; align-items: center; }
.sf2-ip-input-row input { flex: 1 1; min-width: 0; }
.sf2-ip-form-actions { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }

.sf2-ip-actions {
  display: grid;
  gap: 0;
  border-top: 1px solid var(--border);
  padding-top: 6px;
}

.sf2-ip-action-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 7px 2px;
  border-bottom: 1px solid var(--border);
  font-size: 0.82rem;
  color: var(--text-secondary);
}

.sf2-ip-action-row:last-child { border-bottom: 0; }
.sf2-ip-action-row .sf2-ip-addr { min-width: 110px; }
.sf2-ip-action-row > .sf2-link--danger { margin-left: auto; }

.sf2-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.84rem;
  color: var(--text-secondary);
  cursor: pointer;
}

.sf2-check input { width: 15px; height: 15px; accent-color: var(--accent); }
.sf2-error { color: #dc2626; font-size: 0.8rem; }
.sf2-link--danger { color: #dc2626 !important; }

/* ── Organización: roles, switches y AD ─────────────────────────────── */
.sf2-org > .sf2-org-summary { order: -2; }
.sf2-org > .sf2-org-ad { order: -1; }

.sf2-role-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  padding: 0.4rem 0.55rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-primary);
  background: var(--slate-100);
  border: 1px solid var(--border);
}

.sf2-role-badge--manual { background: rgba(99, 102, 241, 0.14); border-color: rgba(99, 102, 241, 0.45); }
.sf2-role-badge--agent { background: rgba(16, 185, 129, 0.14); border-color: rgba(16, 185, 129, 0.45); }

.sf2-role-badge button {
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  font-size: 1rem;
}

.sf2-role-badge button:hover { color: #dc2626; }

.sf2-org input[type="checkbox"] { accent-color: var(--accent); }

.sf2-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

/* El input real es invisible y cubre TODO el interruptor: así se puede pulsar
   en cualquier punto y el navegador no tiene que buscar una caja de 0×0 al
   recibir el foco (eso provocaba saltos de scroll). */
.sf2-switch input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  opacity: 0;
  cursor: pointer;
}

/* Un interruptor dentro de \`.sf2-field\` no debe heredar el estilo de etiqueta
   de campo (bloque, gris y diminuta) o se parte en dos líneas. */
.sf2-field label.sf2-switch {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin: 0;
  font-size: 0.84rem;
  font-weight: 500;
  color: var(--text-primary);
  letter-spacing: normal;
  text-transform: none;
}

.sf2-switch-track {
  display: block;
  position: relative;
  width: 38px;
  height: 20px;
  flex: none;
  border-radius: 999px;
  background: var(--slate-300, #cbd5e1);
  border: 1px solid var(--border);
  transition: background 0.18s ease, border-color 0.18s ease;
}

.sf2-switch-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.28);
  transition: transform 0.18s ease;
}

.sf2-switch input:checked + .sf2-switch-track {
  background: var(--accent);
  border-color: var(--accent);
}

.sf2-switch input:checked + .sf2-switch-track .sf2-switch-thumb {
  transform: translateX(18px);
}

.sf2-switch input:focus-visible + .sf2-switch-track {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

.sf2-switch input:disabled + .sf2-switch-track { opacity: 0.55; }
.sf2-switch-label { font-size: 0.88rem; font-weight: 600; color: var(--text-primary); }

/* Variante compacta (gestor de IPs) */
.sf2-switch--sm .sf2-switch-track { width: 32px; height: 17px; }
.sf2-switch--sm .sf2-switch-thumb { width: 11px; height: 11px; }
.sf2-switch--sm input:checked + .sf2-switch-track .sf2-switch-thumb { transform: translateX(15px); }
.sf2-switch--sm .sf2-switch-label { font-size: 0.8rem; font-weight: 500; }

/* Grupo de interruptores en línea (p. ej. roles FSMO) */
.sf2-switches {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 22px;
}

/* ── Modos de asignación de IPs ─────────────────────────────────────── */
.sf2-mode { display: flex; gap: 6px; flex-wrap: wrap; }

.sf2-mode-btn {
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-secondary);
  border-radius: 999px;
  padding: 5px 12px;
  font: inherit;
  font-size: 0.8rem;
  cursor: pointer;
}

.sf2-mode-btn:hover { border-color: var(--accent); color: var(--text-primary); }
.sf2-mode-btn.active { background: var(--accent); border-color: var(--accent); color: #fff; font-weight: 600; }

.sf2-ip-map { display: grid; gap: 8px; }
.sf2-ip-map-summary { display: flex; gap: 12px; flex-wrap: wrap; font-size: 0.72rem; color: var(--text-muted); }
.sf2-ip-map-summary .libre { color: #16a34a; font-weight: 600; }
.sf2-ip-map-summary .ocupada { color: #dc2626; }
.sf2-ip-map-summary .reservada { color: #d97706; }

.sf2-ip-map-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  max-height: 190px;
  overflow-y: auto;
  padding: 8px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--slate-50);
}

.sf2-ip-cell {
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: 0.66rem;
  padding: 2px 5px;
  border-radius: 4px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-muted);
  cursor: pointer;
}

.sf2-ip-cell--libre { color: #16a34a; border-color: rgba(22, 163, 74, 0.45); background: rgba(34, 197, 94, 0.12); }
.sf2-ip-cell--asignada { color: #b91c1c; border-color: rgba(220, 38, 38, 0.4); background: rgba(239, 68, 68, 0.12); cursor: not-allowed; }
.sf2-ip-cell--reservada { color: #b45309; border-color: rgba(245, 158, 11, 0.45); background: rgba(245, 158, 11, 0.12); cursor: not-allowed; }
.sf2-ip-cell--gw { color: #0369a1; border-color: rgba(14, 165, 233, 0.45); background: rgba(14, 165, 233, 0.12); cursor: default; }
.sf2-ip-cell--sel { background: var(--accent); border-color: var(--accent); color: #fff; font-weight: 700; }
.sf2-ip-cell:disabled { opacity: 0.7; }
.sf2-ip-map-legend { font-size: 0.7rem; color: var(--text-muted); }

.sf2-table-wrap { overflow-x: auto; }

.sf2-table { width: 100%; border-collapse: collapse; font-size: 0.8rem; }
.sf2-table th {
  text-align: left;
  font-weight: 500;
  font-size: 0.72rem;
  color: var(--text-muted);
  padding: 7px 8px;
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
}
.sf2-table td { padding: 8px; border-bottom: 1px solid var(--border); color: var(--text-primary); }
.sf2-table tr:last-child td { border-bottom: 0; }
.sf2-table tbody tr:hover { background: var(--slate-100); }

.sf2-vol-use { display: flex; align-items: center; gap: 8px; min-width: 120px; }
.sf2-vol-use .sf2-bar { flex: 1 1; }
.sf2-vol-use span { font-size: 0.75rem; color: var(--text-muted); min-width: 34px; text-align: right; }

.sf2-empty { padding: 14px 2px; color: var(--text-muted); font-size: 0.84rem; }

/* ── Salto de versión del agente ───────────────────────────────────────────
   Mientras la actualización está viva, la pestaña Agente enseña
   «v2.6.8 → v2.6.9» con la flecha latiendo. Es la única señal de que hay algo
   en marcha mientras el equipo está a punto de perder el latido. */
.sf2-version-flow { display: inline-flex; align-items: center; gap: 6px; }
.sf2-version-flow__arrow {
  width: 15px;
  height: 15px;
  color: var(--amber-600, #d97706);
  animation: sf2-version-pulse 1.1s ease-in-out infinite;
}

@keyframes sf2-version-pulse {
  0%, 100% { opacity: 1; transform: translateX(0); }
  50% { opacity: 0.35; transform: translateX(3px); }
}

@media (prefers-reduced-motion: reduce) {
  .sf2-version-flow__arrow { animation: none; }
}

/* Icono girando para los procesos que se siguen por polling (instalacion de
   actualizaciones, por ejemplo): sin esto el usuario no sabe si algo avanza. */
@keyframes sf2-spin {
  to { transform: rotate(360deg); }
}
.sf2-spin { animation: sf2-spin 1s linear infinite; }

@media (prefers-reduced-motion: reduce) {
  .sf2-spin { animation: none; }
}

/* Las pestañas que no se reescriben (licencia, organización, accesos…) se
   envuelven en una tarjeta para que el aspecto sea consistente. Vale también
   para las fichas que no marcan \`sf2-pane\` en cada pestaña. */
.sf2-pane > .dv-section,
.sf2-scroll > .dv-tab-pane > .dv-section {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg, 10px);
  padding: 16px;
}

.sf2-pane > .dv-section + .dv-section,
.sf2-scroll > .dv-tab-pane > .dv-section + .dv-section { margin-top: 16px; }

@media (max-width: 560px) {
  .sf2-row { align-items: flex-start; flex-direction: column; gap: 4px; }
  .sf2-vol-use { width: 100%; }
}

/* ── Monitor «en vivo» del Resumen ───────────────────────────────────── */
.sf2-live {
  border-color: color-mix(in srgb, var(--accent) 45%, var(--border));
  background:
    linear-gradient(135deg, rgba(var(--accent-rgb), 0.07), transparent 55%),
    var(--bg-card);
}

.sf2-live-head { gap: 10px; }

.sf2-live-title {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-weight: 700;
  color: var(--text-primary);
}

.sf2-live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  animation: sf2LivePulse 2s infinite;
  flex: none;
}

.sf2-live-dot--idle { background: #9ca3af; animation: none; }

@keyframes sf2LivePulse {
  0%   { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55); }
  70%  { box-shadow: 0 0 0 7px rgba(34, 197, 94, 0); }
  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}

.sf2-live-when {
  font-size: 0.72rem;
  color: var(--text-muted);
  font-weight: 500;
  margin-right: auto;
}

.sf2-live-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.sf2-live-metric {
  background: var(--slate-100);
  border-radius: 9px;
  padding: 8px 10px;
  min-width: 0;
}

.sf2-live-metric > span { font-size: 0.7rem; color: var(--text-muted); display: block; }
.sf2-live-metric > b { font-size: 1.1rem; display: block; line-height: 1.2; }
.sf2-live-metric small { font-size: 0.68rem; color: var(--text-muted); }
.sf2-live-spark { height: 24px; margin-top: 2px; }
.sf2-live-nochart { height: 24px; }

/* ── Organización en rejilla de dos columnas ─────────────────────────── */
.sf2-org {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: start;
}

.sf2-org > .dv-section {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg, 10px);
  padding: 16px;
  min-width: 0;
}

.sf2-org > .dv-section + .dv-section { margin-top: 0; }
.sf2-org > .sf2-org-full { grid-column: 1 / -1; }

/* Subgrupos dentro de una tarjeta (roles de Windows, features…) */
.sf2-subgroup { margin-top: 12px; }
.sf2-subgroup:first-of-type { margin-top: 8px; }

.sf2-subtitle {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.sf2-chipset { display: flex; flex-wrap: wrap; gap: 6px; }
.sf2-chipset .sf2-pill { padding: 4px 11px; font-size: 0.78rem; }

/* ── Cifrado de disco (BitLocker) ──────────────────────────────────────────
   Antes era un bloque suelto con estilos en línea dentro de Almacenamiento.
   Ahora es una tarjeta más, con la pill de estado en la cabecera y una fila
   por volumen. */
.sf2-bitlocker h3 { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }

.sf2-bl-vols {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 10px;
}

.sf2-bl-vol {
  display: grid;
  grid-template-columns: 52px minmax(80px, 1fr) minmax(0, 1.6fr) auto;
  gap: 10px;
  align-items: center;
  padding: 7px 10px;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: var(--slate-50);
  font-size: 0.82rem;
}

.sf2-bl-vol-mount { color: var(--text-primary); font-variant-numeric: tabular-nums; }
.sf2-bl-vol-status { color: var(--text-secondary); }
.sf2-bl-vol-meta { color: var(--text-muted); font-size: 0.76rem; }

@media (max-width: 700px) {
  .sf2-bl-vol { grid-template-columns: 52px 1fr; row-gap: 4px; }
  .sf2-bl-vol-meta { grid-column: 1 / -1; }
}

@media (max-width: 900px) {
  .sf2-live-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .sf2-org { grid-template-columns: 1fr; }
  .sf2-org > .sf2-org-full { grid-column: auto; }
}

/* ── Cabecera de ficha en pantallas menores ────────────────────────────────
   En un 14" (o con la ventana a media pantalla) la cabecera acumulaba título,
   miga, tres badges y cinco chips: robaba dos filas y el contenido empezaba
   muy abajo. Aquí se recortan los badges y la miga; los chips que quedan son
   contadores (discos, componentes, usuarios, Docs) y no se ocultan.

   Los umbrales son los mismos que usa \`useCompactViewport\` (alto de 14" y
   ancho donde la cabecera ya no cabe), no solo el ancho: un 1366×768 tiene
   ancho de sobra y se queda sin alto, que es el problema real. */
@media (max-height: 820px), (max-width: 1100px) {
  .sf2-chips { gap: 6px; padding-bottom: 0; }
}

@media (max-width: 1400px) {
  .sf2-head .sf2-badges { flex-wrap: wrap; }
  .sf2-badges .sf2-badge:nth-child(n+4) { display: none; }
}

@media (max-width: 1000px) {
  .sf2-head .sf2-badges { display: none; }
  .sf2-head .sf2-crumb { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ServerFormCards.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;;;;iEAIiE;AACjE;EACE,UAAU;EACV,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ;+BAC6B;EAC7B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;2EAC2E;AAC3E;EACE,SAAO;EACP,aAAa;EACb,UAAU;EACV,MAAM;EACN,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E,cAAc,kBAAkB,EAAE,WAAW,EAAE;;AAE/C;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,4BAA4B,2BAA2B,EAAE;AACzD,+BAA+B,YAAY,EAAE,eAAe,EAAE,2BAA2B,EAAE;;AAE3F;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,2BAA2B,wBAAwB,EAAE;AACrD,oBAAoB,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,wBAAwB,EAAE;;AAErF;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,qFAAqF;AACrF;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,wBAAwB,4BAA4B,EAAE;AACtD,uBAAuB,yCAAyC,EAAE,qCAAqC,EAAE,gBAAgB,EAAE;AAC3H,mBAAmB,UAAU,EAAE,kBAAkB,EAAE;AACnD,mBAAmB,SAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1G,mBAAmB,UAAU,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,gBAAgB,EAAE;AAC9F,oBAAoB,iBAAiB,EAAE,wBAAwB,EAAE,iBAAiB,EAAE;;AAEpF,4EAA4E;AAC5E,0BAA0B,gBAAgB,EAAE;;AAE5C;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,oBAAoB,4BAA4B,EAAE,gBAAgB,EAAE;;AAEpE;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,eAAe,aAAa,EAAE;;AAE9B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,mBAAmB,aAAa,EAAE;AAClC,eAAe,UAAU,EAAE,kBAAkB,EAAE;;AAE/C;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,qBAAqB,qCAAqC,EAAE;;AAE5D;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,kBAAkB,WAAW,EAAE,YAAY,EAAE;AAC7C,oBAAoB,2BAA2B,EAAE,oBAAoB,EAAE;;AAEvE;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ;oEACkE;EAClE,sBAAsB;AACxB;;AAEA;sEACsE;AACtE,aAAa,iBAAiB,EAAE;;AAEhC,4EAA4E;AAC5E;EACE,aAAa;EACb,SAAS;EACT;mDACiD;EACjD,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV;4EAC0E;EAC1E,eAAe;AACjB;;AAEA,kBAAkB,SAAO,EAAE,gBAAgB,EAAE;;AAE7C,8EAA8E;AAC9E,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;;AAEtF;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAEhF;;;;;;;;EAQE;AACF;EACE;;uCAEqC;EACrC,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,uFAAuF;AACzF;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA,+BAA+B,wBAAwB,EAAE,gBAAgB,EAAE;;AAE3E;;uCAEuC;AACvC;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;;kFAEkF;AAClF;EACE,UAAU;EACV,yBAAyB;EACzB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;;EAGE,UAAU;AACZ;;AAEA,kBAAkB,eAAe,EAAE;;AAEnC;yEACyE;AACzE,6BAA6B,kBAAkB,EAAE;;AAEjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,qBAAqB,WAAW,EAAE,YAAY,EAAE;AAChD,uBAAuB,2BAA2B,EAAE,qCAAqC,EAAE;AAC3F,0BAA0B,YAAY,EAAE,eAAe,EAAE;AACzD,qBAAqB,qCAAqC,EAAE,cAAc,EAAE;AAC5E,2BAA2B,qBAAqB,EAAE,cAAc,EAAE;;AAElE;EACE,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,uBAAuB;AACzB;;AAEA,eAAe,4BAA4B,EAAE,gBAAgB,EAAE;;AAE/D,cAAc,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAExD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,gDAAgD;AAClD;;AAEA,kBAAkB,2BAA2B,EAAE;AAC/C,qBAAqB,aAAa,EAAE,eAAe,EAAE,2BAA2B,EAAE;AAClF,cAAc,eAAe,EAAE,0BAA0B,EAAE,cAAc,EAAE;AAC3E,iBAAiB,iBAAiB,EAAE,wBAAwB,EAAE;AAC9D,2BAA2B,uBAAuB,EAAE,oBAAoB,EAAE,eAAe,EAAE;AAC3F,iCAAiC,2BAA2B,EAAE;;AAE9D,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA,YAAY,kBAAkB,EAAE,iBAAiB,EAAE,UAAU,EAAE;;AAE/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB,0BAA0B,EAAE;AAClD,sCAAsC,qCAAqC,EAAE,kCAAkC,EAAE;;AAEjH;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8BAA8B,4BAA4B,EAAE,0BAA0B,EAAE;AACxF,6CAA6C,qCAAqC,EAAE,gBAAgB,EAAE;AACtG,oBAAoB,kBAAkB,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;;AAEtF,4EAA4E;AAC5E,eAAe,aAAa,EAAE,SAAS,EAAE;;AAEzC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;yEACyE;AACzE,eAAe,gDAAgD,EAAE;;AAEjE;iFACiF;AACjF;EACE,2BAA2B,qCAAqC,EAAE;AACpE;;AAEA;EACE,eAAe,0BAA0B,EAAE;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,kBAAkB,wBAAwB,EAAE;AAC5C,sBAAsB,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAEjF;qCACqC,qCAAqC,EAAE,0BAA0B,EAAE;;AAExG;EACE,aAAa;EACb,SAAS;EACT,0DAA0D;AAC5D;;AAEA,aAAa,YAAY,EAAE;;AAE3B;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,0BAA0B,wBAAwB,EAAE,gBAAgB,EAAE;;AAEtE;;;EAGE,WAAW;EACX,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,sBAAsB,gBAAgB,EAAE,gBAAgB,EAAE;;AAE1D;;;EAGE,2BAA2B;EAC3B,aAAa;EACb,mDAAmD;AACrD;;AAEA,YAAY,kBAAkB,EAAE,wBAAwB,EAAE,eAAe,EAAE,cAAc,EAAE;;AAE3F,uEAAuE;AACvE,iBAAiB,aAAa,EAAE,QAAQ,EAAE,oBAAoB,EAAE;AAChE,yBAAyB,cAAc,EAAE,YAAY,EAAE;;AAEvD,6EAA6E;AAC7E;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,8CAA8C;EAC9C,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,yBAAyB,YAAY,EAAE,eAAe,EAAE;;AAExD,8DAA8D;AAC9D,iBAAiB,aAAa,EAAE,SAAS,EAAE,oBAAoB,EAAE,YAAY,EAAE;;AAE/E,4EAA4E;AAC5E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA,kBAAkB,kBAAkB,EAAE,wBAAwB,EAAE;AAChE,eAAe,cAAc,EAAE,iBAAiB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AAChG,iBAAiB,iBAAiB,EAAE,wBAAwB,EAAE;;AAE9D;;;;;EAKE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6EAA6E;AAC7E;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB,kBAAkB,EAAE;EACrC,4BAA4B,cAAc,EAAE;AAC9C;;AAEA,aAAa,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEzE;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,kBAAkB,aAAa,EAAE,QAAQ,EAAE;;AAE3C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,4BAA4B,gBAAgB,EAAE;AAC9C,iCAAiC,wBAAwB,EAAE,mBAAmB,EAAE;;AAEhF,4EAA4E;AAC5E;EACE,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,aAAa,cAAc,EAAE,YAAY,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;;AAE9F,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;AACb;;AAEA,4EAA4E;AAC5E;EACE,cAAc,MAAM,EAAE;AACxB;;AAEA;EACE,8DAA8D;EAC9D,gBAAgB,sBAAsB,EAAE,WAAW,EAAE;EACrD,cAAc,oBAAoB,EAAE;EACpC,YAAY,QAAQ,EAAE;EACtB,kBAAkB,YAAY,EAAE,SAAW,EAAE;EAC7C,kBAAkB,kBAAkB,EAAE,eAAe,EAAE;EACvD,iBAAiB,WAAW,EAAE,YAAY,EAAE;;EAE5C;4EAC0E;EAC1E;IACE,QAAQ;IACR,cAAc;EAChB;;EAEA,8EAA8E;EAC9E;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA,+BAA+B,aAAa,EAAE;EAC9C,gBAAgB,cAAc,EAAE;;EAEhC;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc,MAAM,EAAE;EACtB,qBAAqB,iBAAiB,EAAE;EACxC,gBAAgB,cAAc,EAAE;EAChC,mBAAmB,WAAW,EAAE,uBAAuB,EAAE;AAC3D;;AAEA,4EAA4E;AAC5E,YAAY,aAAa,EAAE,MAAM,EAAE;;AAEnC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,sBAAsB,gBAAgB,EAAE;AACxC,gBAAgB,YAAY,EAAE;AAC9B,kBAAkB,cAAc,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AACpG,sBAAsB,cAAc,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,eAAe,EAAE,uBAAuB,EAAE;;AAE9H;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,gBAAgB,0BAA0B,EAAE,qCAAqC,EAAE,mCAAmC,EAAE;AACxH,iBAAiB,0BAA0B,EAAE,oCAAoC,EAAE,mCAAmC,EAAE;AACxH,gBAAgB,0BAA0B,EAAE,sCAAsC,EAAE,oCAAoC,EAAE;AAC1H,gBAAgB,0BAA0B,EAAE,qCAAqC,EAAE,oCAAoC,EAAE;AACzH,kBAAkB,0BAA0B,EAAE,sCAAsC,EAAE,oCAAoC,EAAE;AAC5H,gBAAgB,0BAA0B,EAAE,sCAAsC,EAAE,oCAAoC,EAAE;;AAE1H,0EAA0E;AAC1E;+BAC+B,WAAW,EAAE;AAC5C,eAAe,kBAAkB,EAAE,qCAAqC,EAAE,iBAAiB,EAAE;AAC7F;EACE,6EAA6E;EAC7E,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,qCAAqC,yCAAyC,EAAE;;AAEhF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,mDAAmD,aAAa,EAAE;AAClE,mCAAmC,YAAY,EAAE,wBAAwB,EAAE;AAC3E,yCAAyC,YAAY,EAAE;AACvD,iCAAiC,mBAAmB,EAAE;;AAEtD,0EAA0E;AAC1E,kBAAkB,aAAa,EAAE,SAAS,EAAE;AAC5C,eAAe,aAAa,EAAE,SAAS,EAAE;AACzC,oBAAoB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAClE,0BAA0B,SAAO,EAAE,YAAY,EAAE;AACjD,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;;AAEvF;EACE,aAAa;EACb,MAAM;EACN,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,gCAAgC,gBAAgB,EAAE;AAClD,kCAAkC,gBAAgB,EAAE;AACpD,yCAAyC,iBAAiB,EAAE;;AAE5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,mBAAmB,WAAW,EAAE,YAAY,EAAE,2BAA2B,EAAE;AAC3E,aAAa,cAAc,EAAE,iBAAiB,EAAE;AAChD,oBAAoB,yBAAyB,EAAE;;AAE/C,0EAA0E;AAC1E,8BAA8B,SAAS,EAAE;AACzC,yBAAyB,SAAS,EAAE;;AAEpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,0BAA0B,oCAAoC,EAAE,sCAAsC,EAAE;AACxG,yBAAyB,oCAAoC,EAAE,sCAAsC,EAAE;;AAEvG;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA,+BAA+B,cAAc,EAAE;;AAE/C,kCAAkC,2BAA2B,EAAE;;AAE/D;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;sDAEsD;AACtD;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;iEACiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qCAAqC;EACrC,+BAA+B;EAC/B,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,iDAAiD,aAAa,EAAE;AAChE,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAEtF,sCAAsC;AACtC,oCAAoC,WAAW,EAAE,YAAY,EAAE;AAC/D,oCAAoC,WAAW,EAAE,YAAY,EAAE;AAC/D,sEAAsE,2BAA2B,EAAE;AACnG,oCAAoC,iBAAiB,EAAE,gBAAgB,EAAE;;AAEzE,wDAAwD;AACxD;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA,0EAA0E;AAC1E,YAAY,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAEtD;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA,sBAAsB,2BAA2B,EAAE,0BAA0B,EAAE;AAC/E,uBAAuB,yBAAyB,EAAE,2BAA2B,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAE9G,cAAc,aAAa,EAAE,QAAQ,EAAE;AACvC,sBAAsB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AAC/G,6BAA6B,cAAc,EAAE,gBAAgB,EAAE;AAC/D,+BAA+B,cAAc,EAAE;AAC/C,iCAAiC,cAAc,EAAE;;AAEjD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;EACtD,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;AACjB;;AAEA,sBAAsB,cAAc,EAAE,qCAAqC,EAAE,mCAAmC,EAAE;AAClH,yBAAyB,cAAc,EAAE,oCAAoC,EAAE,mCAAmC,EAAE,mBAAmB,EAAE;AACzI,0BAA0B,cAAc,EAAE,sCAAsC,EAAE,oCAAoC,EAAE,mBAAmB,EAAE;AAC7I,mBAAmB,cAAc,EAAE,sCAAsC,EAAE,oCAAoC,EAAE,eAAe,EAAE;AAClI,oBAAoB,yBAAyB,EAAE,2BAA2B,EAAE,WAAW,EAAE,gBAAgB,EAAE;AAC3G,wBAAwB,YAAY,EAAE;AACtC,qBAAqB,iBAAiB,EAAE,wBAAwB,EAAE;;AAElE,kBAAkB,gBAAgB,EAAE;;AAEpC,aAAa,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE;AACxE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;AACrB;AACA,gBAAgB,YAAY,EAAE,sCAAsC,EAAE,0BAA0B,EAAE;AAClG,8BAA8B,gBAAgB,EAAE;AAChD,4BAA4B,4BAA4B,EAAE;;AAE1D,eAAe,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC/E,wBAAwB,SAAO,EAAE;AACjC,oBAAoB,kBAAkB,EAAE,wBAAwB,EAAE,eAAe,EAAE,iBAAiB,EAAE;;AAEtG,aAAa,iBAAiB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE;;AAE9E;;;mEAGmE;AACnE,oBAAoB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACzE;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,sDAAsD;AACxD;;AAEA;EACE,WAAW,UAAU,EAAE,wBAAwB,EAAE;EACjD,MAAM,aAAa,EAAE,0BAA0B,EAAE;AACnD;;AAEA;EACE,2BAA2B,eAAe,EAAE;AAC9C;;AAEA;+EAC+E;AAC/E;EACE,KAAK,yBAAyB,EAAE;AAClC;AACA,YAAY,sCAAsC,EAAE;;AAEpD;EACE,YAAY,eAAe,EAAE;AAC/B;;AAEA;;8DAE8D;AAC9D;;EAEE,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;AACf;;AAEA;yDACyD,gBAAgB,EAAE;;AAE3E;EACE,WAAW,uBAAuB,EAAE,sBAAsB,EAAE,QAAQ,EAAE;EACtE,eAAe,WAAW,EAAE;AAC9B;;AAEA,2EAA2E;AAC3E;EACE,kEAAkE;EAClE;;kBAEgB;AAClB;;AAEA,iBAAiB,SAAS,EAAE;;AAE5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,UAAU;AACZ;;AAEA,sBAAsB,mBAAmB,EAAE,eAAe,EAAE;;AAE5D;EACE,OAAO,2CAA2C,EAAE;EACpD,OAAO,0CAA0C,EAAE;EACnD,OAAO,wCAAwC,EAAE;AACnD;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA,0BAA0B,iBAAiB,EAAE,wBAAwB,EAAE,cAAc,EAAE;AACvF,uBAAuB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC5E,yBAAyB,kBAAkB,EAAE,wBAAwB,EAAE;AACvE,kBAAkB,YAAY,EAAE,eAAe,EAAE;AACjD,oBAAoB,YAAY,EAAE;;AAElC,2EAA2E;AAC3E;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,YAAY;AACd;;AAEA,uCAAuC,aAAa,EAAE;AACtD,2BAA2B,mBAAmB,EAAE;;AAEhD,kEAAkE;AAClE,gBAAgB,gBAAgB,EAAE;AAClC,8BAA8B,eAAe,EAAE;;AAE/C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,eAAe,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AACzD,yBAAyB,iBAAiB,EAAE,kBAAkB,EAAE;;AAEhE;;;iBAGiB;AACjB,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAEnF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,oBAAoB,0BAA0B,EAAE,kCAAkC,EAAE;AACpF,qBAAqB,4BAA4B,EAAE;AACnD,mBAAmB,wBAAwB,EAAE,kBAAkB,EAAE;;AAEjE;EACE,cAAc,+BAA+B,EAAE,YAAY,EAAE;EAC7D,mBAAmB,mBAAmB,EAAE;AAC1C;;AAEA;EACE,iBAAiB,gDAAgD,EAAE;EACnE,WAAW,0BAA0B,EAAE;EACvC,2BAA2B,iBAAiB,EAAE;AAChD;;AAEA;;;;;;;;iEAQiE;AACjE;EACE,aAAa,QAAQ,EAAE,iBAAiB,EAAE;AAC5C;;AAEA;EACE,wBAAwB,eAAe,EAAE;EACzC,wCAAwC,aAAa,EAAE;AACzD;;AAEA;EACE,wBAAwB,aAAa,EAAE;EACvC,uBAAuB,aAAa,EAAE;AACxC","sourcesContent":["/**\r\n * Ficha de servidor · variante «tarjetas» (beta).\r\n *\r\n * Todo va prefijado con `sf2-` a propósito: la ficha clásica no debe cambiar\r\n * ni un píxel mientras la beta está detrás del flag. No se reutilizan clases\r\n * estructurales de DetailView (`.dv-body`, `.dv-main`, `.dv-sidebar`) salvo\r\n * las de los paneles que se montan tal cual.\r\n */\r\n\r\n/* ── Cabecera fija ────────────────────────────────────────────────────────\r\n   En la variante tarjetas el scroll NO lo hace `.dv-main`: el formulario se\r\n   queda quieto y scrollea solo `.sf2-scroll`. Así la cabecera y las pestañas\r\n   son hermanas del área desplazable y es materialmente imposible que algo se\r\n   vea por detrás (nada de sticky, nada de trucos de márgenes). */\r\n.dv-main.sf2-main {\r\n  padding: 0;\r\n  gap: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.sf2-headarea {\r\n  position: relative;\r\n  z-index: 5;\r\n  flex: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.65rem;\r\n  /* Sin padding inferior: el borde de las pestañas hace de separador con la\r\n     zona que sí se desplaza. */\r\n  padding: 1.1rem 2rem 0;\r\n  background: var(--slate-50);\r\n}\r\n\r\n/* En fichas con `<fieldset class=\"dv-fieldset\">` (VM), el fieldset hace de\r\n   contenedor principal: tiene que repartir altura como haría `.dv-main`. */\r\n.dv-fieldset.sf2-main {\r\n  flex: 1;\r\n  min-height: 0;\r\n  padding: 0;\r\n  gap: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n/* ── Selector de ubicación en árbol (LocationTreeSelect) ──────────────── */\r\n.sf2-locsel { position: relative; width: 100%; }\r\n\r\n.sf2-locsel-trigger {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 9px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  background: var(--slate-50);\r\n  color: var(--text-primary);\r\n  font: inherit;\r\n  font-size: 0.84rem;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.sf2-locsel-trigger:hover { border-color: var(--accent); }\r\n.sf2-locsel-trigger:disabled { opacity: 0.6; cursor: default; border-color: var(--border); }\r\n\r\n.sf2-locsel-value {\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.sf2-locsel-value--empty { color: var(--text-muted); }\r\n.sf2-locsel-caret { width: 14px; height: 14px; flex: none; color: var(--text-muted); }\r\n\r\n.sf2-locsel-pop {\r\n  position: absolute;\r\n  z-index: 60;\r\n  top: calc(100% + 4px);\r\n  left: 0;\r\n  right: 0;\r\n  max-height: 320px;\r\n  overflow-y: auto;\r\n  padding: 4px;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Variante fija: se mide desde el botón para que no la recorte el scroll del panel */\r\n.sf2-locsel-pop--fixed {\r\n  position: fixed;\r\n  z-index: 3000;\r\n  top: auto;\r\n  right: auto;\r\n  bottom: auto;\r\n}\r\n\r\n.sf2-locsel-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  width: 100%;\r\n  padding: 5px 10px;\r\n  border: 0;\r\n  border-radius: 6px;\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n  font: inherit;\r\n  font-size: 0.82rem;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.sf2-locsel-row:hover { background: var(--slate-100); }\r\n.sf2-locsel-row--sel { background: rgba(var(--accent-rgb), 0.12); color: var(--accent-l, var(--accent)); font-weight: 600; }\r\n.sf2-locsel-icon { flex: none; font-size: 0.85rem; }\r\n.sf2-locsel-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\r\n.sf2-locsel-type { flex: none; font-size: 0.7rem; color: var(--text-muted); font-weight: 400; }\r\n.sf2-locsel-empty { padding: 8px 10px; color: var(--text-muted); font-size: 0.8rem; }\r\n\r\n/* ── Organigrama de ubicaciones ───────────────────────────────────────── */\r\n.sf2-grid > .dv-section { margin-bottom: 0; }\r\n\r\n.sf2-orgcaption {\r\n  font-size: 0.74rem;\r\n  color: var(--text-muted);\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.sf2-orgcaption b { color: var(--text-secondary); font-weight: 600; }\r\n\r\n.sf2-orgtree,\r\n.sf2-orgchildren {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.sf2-orgchildren {\r\n  margin-left: 14px;\r\n  padding-left: 14px;\r\n  border-left: 1px dashed var(--border);\r\n}\r\n\r\n.sf2-orgnode { margin: 4px 0; }\r\n\r\n.sf2-orgrow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 5px 8px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  background: var(--bg-card);\r\n}\r\n\r\n.sf2-orgrow--current {\r\n  border-color: var(--accent);\r\n  background: rgba(var(--accent-rgb), 0.08);\r\n}\r\n\r\n.sf2-orgrow--off { opacity: 0.55; }\r\n.sf2-orgicon { flex: none; font-size: 0.95rem; }\r\n\r\n.sf2-orgname {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: grid;\r\n  gap: 1px;\r\n  text-align: left;\r\n  border: 0;\r\n  background: transparent;\r\n  padding: 0;\r\n  font: inherit;\r\n  font-size: 0.86rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n}\r\n\r\n.sf2-orgname small {\r\n  font-size: 0.7rem;\r\n  font-weight: 400;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.sf2-orgname:hover { color: var(--accent-l, var(--accent)); }\r\n\r\n.sf2-orgadd {\r\n  flex: none;\r\n  display: inline-grid;\r\n  place-items: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n}\r\n\r\n.sf2-orgadd svg { width: 14px; height: 14px; }\r\n.sf2-orgadd:hover { border-color: var(--accent); color: var(--accent); }\r\n\r\n.sf2-scroll {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.25rem;\r\n  /* Sin padding superior: `.dv-tab-pane` ya aporta 1.25rem bajo la línea de\r\n     pestañas. Así el contenido arranca pegado y se gana pantalla. */\r\n  padding: 0 2rem 1.5rem;\r\n}\r\n\r\n/* En la ficha clásica los envoltorios no deben existir: los hijos vuelven a ser\r\n   items directos del formulario y conservan el `gap` de `.dv-main`. */\r\n.sf2-plain { display: contents; }\r\n\r\n/* ── Cabecera ─────────────────────────────────────────────────────────── */\r\n.sf2-head {\r\n  display: flex;\r\n  gap: 12px;\r\n  /* El icono se alinea con la línea del título, no con el centro del bloque\r\n     (que incluye la migaja y queda descuadrado). */\r\n  align-items: flex-start;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.sf2-head-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 10px;\r\n  background: var(--slate-100);\r\n  border: 1px solid var(--border);\r\n  display: grid;\r\n  place-items: center;\r\n  color: var(--accent);\r\n  flex: none;\r\n  /* El título arranca un pelo por debajo del borde del icono: así las dos\r\n     primeras líneas quedan ópticamente alineadas sin tocar la tipografía. */\r\n  margin-top: 1px;\r\n}\r\n\r\n.sf2-head-title { flex: 1; min-width: 200px; }\r\n\r\n/* Interruptores de estado dentro de una tarjeta de campos (Identificación). */\r\n.sf2-field-switches { display: flex; align-items: center; gap: 18px; flex-wrap: wrap; }\r\n\r\n.sf2-head-title h1 {\r\n  margin: 0;\r\n  font-size: 1.3rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  line-height: 1.2;\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.sf2-title-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }\r\n\r\n/* Título editable de una ficha con patrón *inline edit*:\r\n *\r\n *   · En reposo se ve como el h1 de una ficha de solo lectura: sin caja, con\r\n *     la tipografía del título y el ancho justo del texto.\r\n *   · Al pasar el ratón aparece un borde tenue y el lápiz de la derecha.\r\n *   · Al enfocar (clic o tabulador) se marca con el color primario, fondo de\r\n *     campo y anillo de foco, sin mover nada de sitio (el borde es interior y\r\n *     el padding se compensa con margen negativo).\r\n */\r\n.sf2-head-input {\r\n  /* El ancho sigue al texto. `field-sizing` lo resuelve solo en Chrome/Edge\r\n     recientes; el respaldo calcula con el número de caracteres que publica el\r\n     componente en `--sf2-title-len`. */\r\n  field-sizing: content;\r\n  min-width: 8ch;\r\n  max-width: min(60ch, 100%);\r\n  border: 1px solid transparent;\r\n  border-radius: 8px;\r\n  background: transparent;\r\n  padding: 2px 6px;\r\n  margin: -2px -6px;\r\n  outline: none;\r\n  font: inherit;\r\n  font-size: 1.6rem;\r\n  font-weight: 600;\r\n  letter-spacing: -0.01em;\r\n  color: var(--text-primary);\r\n  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n@supports not (field-sizing: content) {\r\n  .sf2-head-input {\r\n    width: calc(var(--sf2-title-len, 12) * 0.56em + 1em);\r\n  }\r\n}\r\n\r\n.sf2-head-input::placeholder { color: var(--text-muted); font-weight: 600; }\r\n\r\n/* En modo lectura el título NO se pinta como un campo: al pasar el ratón solo\r\n * aparece el lápiz, sin borde ni fondo. El marco llega con el foco, que es\r\n * cuando de verdad se está editando. */\r\n.sf2-head-input:focus {\r\n  border-color: var(--accent);\r\n  background: var(--bg-input);\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.18);\r\n}\r\n\r\n/* El lápiz solo se ve cuando se apunta al título (o con el foco dentro), que es\r\n   lo que anuncia que el nombre se puede editar. Sin caja: es una pista, no un\r\n   botón de modo. Se anula la caja de `.sf2-title-btn`, que sí la necesitan ✓/✕. */\r\n.sf2-title-btn.sf2-title-pencil {\r\n  opacity: 0;\r\n  border-color: transparent;\r\n  background: transparent;\r\n  transition: opacity 0.15s ease;\r\n}\r\n\r\n.sf2-title-btn.sf2-title-pencil:hover {\r\n  border-color: var(--border);\r\n  color: var(--accent-l, var(--accent));\r\n}\r\n\r\n.sf2-title-row:hover .sf2-title-pencil,\r\n.sf2-title-row:focus-within .sf2-title-pencil,\r\n.sf2-title-pencil:focus-visible {\r\n  opacity: 1;\r\n}\r\n\r\n.sf2-head-chips { margin-top: 6px; }\r\n\r\n/* `.dv-tabs-nav` tiene `overflow-x: auto`, lo que en Chrome activa también el\r\n   eje vertical y saca una barra de scroll inútil junto a las pestañas. */\r\n.sf2-headarea .dv-tabs-nav { overflow-y: hidden; }\r\n\r\n.sf2-title-btn {\r\n  display: inline-grid;\r\n  place-items: center;\r\n  width: 30px;\r\n  height: 30px;\r\n  flex: none;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n}\r\n\r\n.sf2-title-btn svg { width: 16px; height: 16px; }\r\n.sf2-title-btn:hover { border-color: var(--accent); color: var(--accent-l, var(--accent)); }\r\n.sf2-title-btn:disabled { opacity: 0.5; cursor: default; }\r\n.sf2-title-btn--ok { border-color: rgba(34, 197, 94, 0.45); color: #16a34a; }\r\n.sf2-title-btn--ok:hover { border-color: #16a34a; color: #16a34a; }\r\n\r\n.sf2-crumb {\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted);\r\n  margin-top: 0;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.sf2-crumb b { color: var(--text-secondary); font-weight: 600; }\r\n\r\n.sf2-badges { display: flex; gap: 6px; flex-wrap: wrap; }\r\n\r\n.sf2-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 2px 10px;\r\n  border-radius: 999px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  background: var(--slate-100);\r\n  border: 1px solid var(--border);\r\n  color: var(--text-secondary);\r\n  white-space: nowrap;\r\n}\r\n\r\n.sf2-badge i {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: var(--c, #22c55e);\r\n  flex: none;\r\n}\r\n\r\n/* ── Chips de relaciones ──────────────────────────────────────────────── */\r\n.sf2-chips {\r\n  display: flex;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n}\r\n\r\n.sf2-chip {\r\n  display: inline-flex;\r\n  align-items: baseline;\r\n  gap: 6px;\r\n  padding: 5px 11px;\r\n  border-radius: 8px;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  font: inherit;\r\n  transition: border-color 0.15s, background 0.15s;\r\n}\r\n\r\n.sf2-chip:hover { border-color: var(--accent); }\r\n.sf2-chip:disabled { opacity: 0.55; cursor: default; border-color: var(--border); }\r\n.sf2-chip b { font-size: 1rem; color: var(--text-primary); line-height: 1; }\r\n.sf2-chip span { font-size: 0.8rem; color: var(--text-muted); }\r\n.sf2-chip.sf2-chip--flat { background: transparent; border-style: dashed; cursor: default; }\r\n.sf2-chip.sf2-chip--flat:hover { border-color: var(--border); }\r\n\r\n/* ── Pestañas con menú «Más» ──────────────────────────────────────────── */\r\n.sf2-tabs {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 0;\r\n  border-bottom: 2px solid var(--border);\r\n  position: relative;\r\n}\r\n\r\n.sf2-more { position: relative; margin-left: auto; flex: none; }\r\n\r\n.sf2-more-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 0.55rem 0.9rem;\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  font: inherit;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  border-bottom: 2px solid transparent;\r\n  margin-bottom: -2px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.sf2-more-btn:hover { color: var(--text-primary); }\r\n.sf2-more-btn[aria-expanded=\"true\"] { color: var(--accent-l, var(--accent)); border-bottom-color: var(--accent); }\r\n\r\n.sf2-more-menu {\r\n  position: absolute;\r\n  right: 0;\r\n  top: calc(100% + 6px);\r\n  min-width: 230px;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  padding: 4px;\r\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);\r\n  z-index: 30;\r\n}\r\n\r\n.sf2-more-menu button {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 7px 10px;\r\n  border: 0;\r\n  border-radius: 7px;\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  font: inherit;\r\n  font-size: 0.84rem;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.sf2-more-menu button:hover { background: var(--slate-100); color: var(--text-primary); }\r\n.sf2-more-menu button[aria-current=\"true\"] { color: var(--accent-l, var(--accent)); font-weight: 600; }\r\n.sf2-more-menu em { font-style: normal; font-size: 0.72rem; color: var(--text-muted); }\r\n\r\n/* ── Resumen: tarjetas y campos ───────────────────────────────────────── */\r\n.sf2-summary { display: grid; gap: 16px; }\r\n\r\n.sf2-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\r\n  gap: 16px;\r\n  align-items: start;\r\n}\r\n\r\n/* Dos columnas fijas: en fichas anchas `auto-fit` reparte en 3-4 columnas y\r\n   las tarjetas quedan estrechas. Es el patrón del Resumen de servidor. */\r\n.sf2-grid--2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n\r\n/* Con dos columnas y poco ancho (panel lateral abierto en portátil) los campos\r\n   quedan a 50 px. Mientras siga habiendo dos columnas, los campos pasan a uno. */\r\n@media (min-width: 901px) and (max-width: 1280px) {\r\n  .sf2-grid--2 .sf2-fields { grid-template-columns: minmax(0, 1fr); }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .sf2-grid--2 { grid-template-columns: 1fr; }\r\n}\r\n\r\n.sf2-card {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg, 10px);\r\n  padding: 16px;\r\n  min-width: 0;\r\n}\r\n\r\n.sf2-card h3 {\r\n  margin: 0 0 12px;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.sf2-card h3 a,\r\n.sf2-card h3 button.sf2-link {\r\n  background: none;\r\n  border: 0;\r\n  padding: 0;\r\n  font: inherit;\r\n  font-size: 0.76rem;\r\n  font-weight: 500;\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n}\r\n\r\n.sf2-link {\r\n  background: none;\r\n  border: 0;\r\n  padding: 0;\r\n  font: inherit;\r\n  color: var(--accent-l, var(--accent));\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n  text-align: left;\r\n}\r\n\r\n.sf2-link:hover { filter: brightness(1.12); }\r\n.sf2-hint .sf2-link { font-size: inherit; font-weight: 600; white-space: nowrap; }\r\n\r\n.sf2-card h3 a:hover,\r\n.sf2-card h3 button.sf2-link:hover { color: var(--accent-l, var(--accent)); text-decoration: underline; }\r\n\r\n.sf2-fields {\r\n  display: grid;\r\n  gap: 14px;\r\n  grid-template-columns: repeat(var(--n, 2), minmax(0, 1fr));\r\n}\r\n\r\n.sf2-field { min-width: 0; }\r\n\r\n.sf2-field label {\r\n  display: block;\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.sf2-field .v {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  min-height: 26px;\r\n  font-size: 0.86rem;\r\n  font-weight: 500;\r\n  color: var(--text-primary);\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.sf2-field .v.sf2-muted { color: var(--text-muted); font-weight: 400; }\r\n\r\n.sf2-field input,\r\n.sf2-field select,\r\n.sf2-field textarea {\r\n  width: 100%;\r\n  background: var(--slate-50);\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  padding: 6px 9px;\r\n  font: inherit;\r\n  font-size: 0.84rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.sf2-field textarea { resize: vertical; min-height: 64px; }\r\n\r\n.sf2-field input:focus,\r\n.sf2-field select:focus,\r\n.sf2-field textarea:focus {\r\n  border-color: var(--accent);\r\n  outline: none;\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.18);\r\n}\r\n\r\n.sf2-hint { font-size: 0.72rem; color: var(--text-muted); margin-top: 4px; display: block; }\r\n\r\n/* Campo con una acción pegada al lado (Código + generar en el rack). */\r\n.sf2-input-row { display: flex; gap: 6px; align-items: stretch; }\r\n.sf2-input-row > input { flex: 1 1 auto; min-width: 0; }\r\n\r\n/* Campo compacto dentro de una tabla: edición EN LA LÍNEA (registros DNS). */\r\n.sf2-cell-input {\r\n  width: 100%;\r\n  min-width: 0;\r\n  padding: 4px 6px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 6px;\r\n  background: var(--bg-input, var(--bg-toolbar));\r\n  color: var(--text-primary);\r\n  font-size: 0.78rem;\r\n  font-family: inherit;\r\n}\r\n\r\n.sf2-cell-input:focus {\r\n  outline: none;\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.15);\r\n}\r\n\r\n.sf2-icon-btn {\r\n  flex: none;\r\n  width: 30px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0;\r\n  background: var(--slate-50);\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  color: var(--accent);\r\n  cursor: pointer;\r\n}\r\n\r\n.sf2-icon-btn:hover:not(:disabled) {\r\n  border-color: var(--accent);\r\n  background: rgba(var(--accent-rgb), 0.10);\r\n}\r\n\r\n.sf2-icon-btn:disabled { opacity: 0.5; cursor: default; }\r\n\r\n/* Dos tarjetas apiladas ocupando una sola columna del grid. */\r\n.sf2-col-stack { display: grid; gap: 16px; align-content: start; min-width: 0; }\r\n\r\n/* ── Salud ────────────────────────────────────────────────────────────── */\r\n.sf2-hl {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\r\n  gap: 10px;\r\n}\r\n\r\n.sf2-kpi {\r\n  background: var(--slate-100);\r\n  border-radius: 9px;\r\n  padding: 10px 12px;\r\n  min-width: 0;\r\n}\r\n\r\n.sf2-kpi > span { font-size: 0.72rem; color: var(--text-muted); }\r\n.sf2-kpi > b { display: block; font-size: 1.2rem; color: var(--text-primary); line-height: 1.2; }\r\n.sf2-kpi small { font-size: 0.7rem; color: var(--text-muted); }\r\n\r\n/* ── Ocupación (bloque unificado) ──────────────────────────────────────\r\n * Un solo bloque en lugar de las cinco tarjetas de KPIs: cifra grande arriba,\r\n * barra segmentada (un segmento por U) y leyenda debajo. Los segmentos usan el\r\n * acento del tema para lo ocupado y `--slate-300` para lo libre, que existe en\r\n * las 12 paletas (claro y oscuro).\r\n */\r\n.sf2-occ {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  min-width: 0;\r\n}\r\n\r\n.sf2-occ-top {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: 10px 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.sf2-occ-title {\r\n  font-size: 1.15rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  line-height: 1.25;\r\n}\r\n\r\n.sf2-occ-pct {\r\n  font-size: 0.8rem;\r\n  color: var(--text-muted);\r\n  white-space: nowrap;\r\n}\r\n\r\n.sf2-occ-bar {\r\n  display: flex;\r\n  gap: 2px;\r\n  height: 14px;\r\n  width: 100%;\r\n}\r\n\r\n.sf2-occ-seg {\r\n  flex: 1;\r\n  min-width: 0;\r\n  border-radius: 2px;\r\n  background: var(--slate-300);\r\n}\r\n\r\n.sf2-occ-seg.is-on {\r\n  background: var(--accent);\r\n}\r\n\r\n/* Racks muy altos (>60U): una barra continua, que 90 segmentos no se leen. */\r\n.sf2-occ-track {\r\n  height: 14px;\r\n  width: 100%;\r\n  border-radius: 2px;\r\n  background: var(--slate-300);\r\n  overflow: hidden;\r\n}\r\n\r\n.sf2-occ-fill {\r\n  display: block;\r\n  height: 100%;\r\n  border-radius: 2px;\r\n  background: var(--accent);\r\n  transition: width 0.2s ease;\r\n}\r\n\r\n.sf2-occ-legend {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px 16px;\r\n  flex-wrap: wrap;\r\n  font-size: 0.78rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sf2-occ-legend b {\r\n  color: var(--text-primary);\r\n  font-weight: 700;\r\n}\r\n\r\n.sf2-occ-legend .sf2-link {\r\n  margin-left: auto;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .sf2-occ-title { font-size: 1.02rem; }\r\n  .sf2-occ-legend .sf2-link { margin-left: 0; }\r\n}\r\n\r\n.sf2-spark { width: 100%; height: 28px; display: block; margin-top: 4px; }\r\n\r\n.sf2-alert {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  padding: 9px 14px;\r\n  border-radius: 9px;\r\n  background: rgba(245, 158, 11, 0.12);\r\n  border: 1px solid rgba(245, 158, 11, 0.42);\r\n  color: var(--text-primary);\r\n  font-size: 0.84rem;\r\n}\r\n\r\n.sf2-alert-list { display: grid; gap: 2px; }\r\n\r\n.sf2-alert-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  padding: 7px 2px;\r\n  border-bottom: 1px solid var(--border);\r\n  font-size: 0.84rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sf2-alert-row:last-child { border-bottom: 0; }\r\n.sf2-alert-row span:last-child { color: var(--text-muted); white-space: nowrap; }\r\n\r\n/* ── Completitud ──────────────────────────────────────────────────────── */\r\n.sf2-bar {\r\n  height: 6px;\r\n  background: var(--slate-200);\r\n  border-radius: 9px;\r\n  overflow: hidden;\r\n}\r\n\r\n.sf2-bar i { display: block; height: 100%; background: var(--accent); transition: width 0.3s; }\r\n\r\n/* ── Dock de cambios sin guardar ──────────────────────────────────────── */\r\n.sf2-dock {\r\n  position: sticky;\r\n  bottom: 12px;\r\n  margin-top: 16px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  background: var(--slate-100);\r\n  border: 1px solid var(--accent);\r\n  border-radius: 12px;\r\n  padding: 10px 14px;\r\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\r\n  font-size: 0.84rem;\r\n  color: var(--text-primary);\r\n  z-index: 20;\r\n}\r\n\r\n/* ── Responsive ───────────────────────────────────────────────────────── */\r\n@media (max-width: 900px) {\r\n  .sf2-fields { --n: 2; }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  /* Cabecera y contenido con el aire de una pantalla de dedo. */\r\n  .sf2-headarea { padding: 0.9rem 1rem 0; gap: 0.5rem; }\r\n  .sf2-scroll { padding: 0 1rem 1rem; }\r\n  .sf2-head { gap: 9px; }\r\n  .sf2-head-title { min-width: 0; flex: 1 1 0; }\r\n  .sf2-head-input { font-size: 1.25rem; max-width: 100%; }\r\n  .sf2-head-icon { width: 34px; height: 34px; }\r\n\r\n  /* Los badges (Activo · Producción · Sin agente) medían 282 px y dejaban el\r\n     título en una columna de 24 px: una letra por línea. Bajan a su fila. */\r\n  .sf2-badges {\r\n    order: 9;\r\n    flex: 1 1 100%;\r\n  }\r\n\r\n  /* Ocho pestañas en tres filas ocupaban 116 px: en una sola fila con scroll. */\r\n  .sf2-tabs {\r\n    flex-wrap: nowrap;\r\n    overflow-x: auto;\r\n    scrollbar-width: none;\r\n  }\r\n\r\n  .sf2-tabs::-webkit-scrollbar { display: none; }\r\n  .sf2-tabs > * { flex-shrink: 0; }\r\n\r\n  .sf2-dock {\r\n    bottom: 8px;\r\n    padding: 9px 12px;\r\n  }\r\n}\r\n\r\n@media (max-width: 560px) {\r\n  .sf2-fields { --n: 1; }\r\n  .sf2-head-title h1 { font-size: 1.2rem; }\r\n  .sf2-dock > * { flex: 1 1 100%; }\r\n  .sf2-dock button { width: 100%; justify-content: center; }\r\n}\r\n\r\n/* ── Listados dentro de tarjetas ──────────────────────────────────────── */\r\n.sf2-rows { display: grid; gap: 0; }\r\n\r\n.sf2-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 9px 2px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.sf2-row:last-child { border-bottom: 0; }\r\n.sf2-row-main { min-width: 0; }\r\n.sf2-row-main b { display: block; font-size: 0.86rem; color: var(--text-primary); font-weight: 600; }\r\n.sf2-row-main small { display: block; font-size: 0.75rem; color: var(--text-muted); margin-top: 2px; overflow-wrap: anywhere; }\r\n\r\n.sf2-count {\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  color: var(--text-muted);\r\n  background: var(--slate-100);\r\n  border-radius: 999px;\r\n  padding: 1px 8px;\r\n}\r\n\r\n.sf2-pill {\r\n  display: inline-block;\r\n  padding: 1px 8px;\r\n  border-radius: 999px;\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  background: var(--slate-100);\r\n  border: 1px solid var(--border);\r\n  color: var(--text-muted);\r\n  white-space: nowrap;\r\n}\r\n\r\n.sf2-pill--ok { color: var(--text-primary); border-color: rgba(34, 197, 94, 0.45); background: rgba(34, 197, 94, 0.16); }\r\n.sf2-pill--bad { color: var(--text-primary); border-color: rgba(239, 68, 68, 0.5); background: rgba(239, 68, 68, 0.18); }\r\n.sf2-pill--ac { color: var(--text-primary); border-color: rgba(99, 102, 241, 0.45); background: rgba(99, 102, 241, 0.14); }\r\n.sf2-pill--wa { color: var(--text-primary); border-color: rgba(245, 158, 11, 0.5); background: rgba(245, 158, 11, 0.16); }\r\n.sf2-pill--info { color: var(--text-primary); border-color: rgba(14, 165, 233, 0.45); background: rgba(14, 165, 233, 0.14); }\r\n.sf2-pill--vi { color: var(--text-primary); border-color: rgba(139, 92, 246, 0.45); background: rgba(139, 92, 246, 0.14); }\r\n\r\n/* ── IPs asignadas ──────────────────────────────────────────────────── */\r\n.sf2-ip-table th:first-child,\r\n.sf2-ip-table td:first-child { width: 24px; }\r\n.sf2-ip-star { text-align: center; color: var(--accent-l, var(--accent)); font-size: 0.9rem; }\r\n.sf2-ip-addr {\r\n  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n.sf2-ip-table tr.sf2-ip-primary td { background: rgba(var(--accent-rgb), 0.07); }\r\n\r\n.sf2-ip-manage {\r\n  margin-top: 14px;\r\n  padding-top: 10px;\r\n  border-top: 1px solid var(--border);\r\n}\r\n\r\n.sf2-ip-manage > summary {\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  list-style: none;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  color: var(--accent-l, var(--accent));\r\n}\r\n\r\n.sf2-ip-manage > summary::-webkit-details-marker { display: none; }\r\n.sf2-ip-manage > summary::before { content: '▸'; color: var(--text-muted); }\r\n.sf2-ip-manage[open] > summary::before { content: '▾'; }\r\n.sf2-ip-manage[open] > summary { margin-bottom: 12px; }\r\n\r\n/* ── Gestor de IPs (sustituye al panel antiguo) ─────────────────────── */\r\n.sf2-ip-manager { display: grid; gap: 14px; }\r\n.sf2-ip-form { display: grid; gap: 12px; }\r\n.sf2-ip-input-row { display: flex; gap: 8px; align-items: center; }\r\n.sf2-ip-input-row input { flex: 1; min-width: 0; }\r\n.sf2-ip-form-actions { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }\r\n\r\n.sf2-ip-actions {\r\n  display: grid;\r\n  gap: 0;\r\n  border-top: 1px solid var(--border);\r\n  padding-top: 6px;\r\n}\r\n\r\n.sf2-ip-action-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  padding: 7px 2px;\r\n  border-bottom: 1px solid var(--border);\r\n  font-size: 0.82rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sf2-ip-action-row:last-child { border-bottom: 0; }\r\n.sf2-ip-action-row .sf2-ip-addr { min-width: 110px; }\r\n.sf2-ip-action-row > .sf2-link--danger { margin-left: auto; }\r\n\r\n.sf2-check {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.84rem;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n}\r\n\r\n.sf2-check input { width: 15px; height: 15px; accent-color: var(--accent); }\r\n.sf2-error { color: #dc2626; font-size: 0.8rem; }\r\n.sf2-link--danger { color: #dc2626 !important; }\r\n\r\n/* ── Organización: roles, switches y AD ─────────────────────────────── */\r\n.sf2-org > .sf2-org-summary { order: -2; }\r\n.sf2-org > .sf2-org-ad { order: -1; }\r\n\r\n.sf2-role-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  border-radius: 6px;\r\n  padding: 0.4rem 0.55rem;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  background: var(--slate-100);\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n.sf2-role-badge--manual { background: rgba(99, 102, 241, 0.14); border-color: rgba(99, 102, 241, 0.45); }\r\n.sf2-role-badge--agent { background: rgba(16, 185, 129, 0.14); border-color: rgba(16, 185, 129, 0.45); }\r\n\r\n.sf2-role-badge button {\r\n  border: 0;\r\n  background: transparent;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  line-height: 1;\r\n  font-size: 1rem;\r\n}\r\n\r\n.sf2-role-badge button:hover { color: #dc2626; }\r\n\r\n.sf2-org input[type=\"checkbox\"] { accent-color: var(--accent); }\r\n\r\n.sf2-switch {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n/* El input real es invisible y cubre TODO el interruptor: así se puede pulsar\r\n   en cualquier punto y el navegador no tiene que buscar una caja de 0×0 al\r\n   recibir el foco (eso provocaba saltos de scroll). */\r\n.sf2-switch input {\r\n  position: absolute;\r\n  inset: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  border: 0;\r\n  background: none;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Un interruptor dentro de `.sf2-field` no debe heredar el estilo de etiqueta\r\n   de campo (bloque, gris y diminuta) o se parte en dos líneas. */\r\n.sf2-field label.sf2-switch {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  margin: 0;\r\n  font-size: 0.84rem;\r\n  font-weight: 500;\r\n  color: var(--text-primary);\r\n  letter-spacing: normal;\r\n  text-transform: none;\r\n}\r\n\r\n.sf2-switch-track {\r\n  display: block;\r\n  position: relative;\r\n  width: 38px;\r\n  height: 20px;\r\n  flex: none;\r\n  border-radius: 999px;\r\n  background: var(--slate-300, #cbd5e1);\r\n  border: 1px solid var(--border);\r\n  transition: background 0.18s ease, border-color 0.18s ease;\r\n}\r\n\r\n.sf2-switch-thumb {\r\n  position: absolute;\r\n  top: 2px;\r\n  left: 2px;\r\n  width: 14px;\r\n  height: 14px;\r\n  border-radius: 50%;\r\n  background: #fff;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.28);\r\n  transition: transform 0.18s ease;\r\n}\r\n\r\n.sf2-switch input:checked + .sf2-switch-track {\r\n  background: var(--accent);\r\n  border-color: var(--accent);\r\n}\r\n\r\n.sf2-switch input:checked + .sf2-switch-track .sf2-switch-thumb {\r\n  transform: translateX(18px);\r\n}\r\n\r\n.sf2-switch input:focus-visible + .sf2-switch-track {\r\n  outline: 2px solid var(--accent);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.sf2-switch input:disabled + .sf2-switch-track { opacity: 0.55; }\r\n.sf2-switch-label { font-size: 0.88rem; font-weight: 600; color: var(--text-primary); }\r\n\r\n/* Variante compacta (gestor de IPs) */\r\n.sf2-switch--sm .sf2-switch-track { width: 32px; height: 17px; }\r\n.sf2-switch--sm .sf2-switch-thumb { width: 11px; height: 11px; }\r\n.sf2-switch--sm input:checked + .sf2-switch-track .sf2-switch-thumb { transform: translateX(15px); }\r\n.sf2-switch--sm .sf2-switch-label { font-size: 0.8rem; font-weight: 500; }\r\n\r\n/* Grupo de interruptores en línea (p. ej. roles FSMO) */\r\n.sf2-switches {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px 22px;\r\n}\r\n\r\n/* ── Modos de asignación de IPs ─────────────────────────────────────── */\r\n.sf2-mode { display: flex; gap: 6px; flex-wrap: wrap; }\r\n\r\n.sf2-mode-btn {\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary);\r\n  border-radius: 999px;\r\n  padding: 5px 12px;\r\n  font: inherit;\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.sf2-mode-btn:hover { border-color: var(--accent); color: var(--text-primary); }\r\n.sf2-mode-btn.active { background: var(--accent); border-color: var(--accent); color: #fff; font-weight: 600; }\r\n\r\n.sf2-ip-map { display: grid; gap: 8px; }\r\n.sf2-ip-map-summary { display: flex; gap: 12px; flex-wrap: wrap; font-size: 0.72rem; color: var(--text-muted); }\r\n.sf2-ip-map-summary .libre { color: #16a34a; font-weight: 600; }\r\n.sf2-ip-map-summary .ocupada { color: #dc2626; }\r\n.sf2-ip-map-summary .reservada { color: #d97706; }\r\n\r\n.sf2-ip-map-grid {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 3px;\r\n  max-height: 190px;\r\n  overflow-y: auto;\r\n  padding: 8px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  background: var(--slate-50);\r\n}\r\n\r\n.sf2-ip-cell {\r\n  font-family: var(--font-mono, ui-monospace, monospace);\r\n  font-size: 0.66rem;\r\n  padding: 2px 5px;\r\n  border-radius: 4px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n}\r\n\r\n.sf2-ip-cell--libre { color: #16a34a; border-color: rgba(22, 163, 74, 0.45); background: rgba(34, 197, 94, 0.12); }\r\n.sf2-ip-cell--asignada { color: #b91c1c; border-color: rgba(220, 38, 38, 0.4); background: rgba(239, 68, 68, 0.12); cursor: not-allowed; }\r\n.sf2-ip-cell--reservada { color: #b45309; border-color: rgba(245, 158, 11, 0.45); background: rgba(245, 158, 11, 0.12); cursor: not-allowed; }\r\n.sf2-ip-cell--gw { color: #0369a1; border-color: rgba(14, 165, 233, 0.45); background: rgba(14, 165, 233, 0.12); cursor: default; }\r\n.sf2-ip-cell--sel { background: var(--accent); border-color: var(--accent); color: #fff; font-weight: 700; }\r\n.sf2-ip-cell:disabled { opacity: 0.7; }\r\n.sf2-ip-map-legend { font-size: 0.7rem; color: var(--text-muted); }\r\n\r\n.sf2-table-wrap { overflow-x: auto; }\r\n\r\n.sf2-table { width: 100%; border-collapse: collapse; font-size: 0.8rem; }\r\n.sf2-table th {\r\n  text-align: left;\r\n  font-weight: 500;\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n  padding: 7px 8px;\r\n  border-bottom: 1px solid var(--border);\r\n  white-space: nowrap;\r\n}\r\n.sf2-table td { padding: 8px; border-bottom: 1px solid var(--border); color: var(--text-primary); }\r\n.sf2-table tr:last-child td { border-bottom: 0; }\r\n.sf2-table tbody tr:hover { background: var(--slate-100); }\r\n\r\n.sf2-vol-use { display: flex; align-items: center; gap: 8px; min-width: 120px; }\r\n.sf2-vol-use .sf2-bar { flex: 1; }\r\n.sf2-vol-use span { font-size: 0.75rem; color: var(--text-muted); min-width: 34px; text-align: right; }\r\n\r\n.sf2-empty { padding: 14px 2px; color: var(--text-muted); font-size: 0.84rem; }\r\n\r\n/* ── Salto de versión del agente ───────────────────────────────────────────\r\n   Mientras la actualización está viva, la pestaña Agente enseña\r\n   «v2.6.8 → v2.6.9» con la flecha latiendo. Es la única señal de que hay algo\r\n   en marcha mientras el equipo está a punto de perder el latido. */\r\n.sf2-version-flow { display: inline-flex; align-items: center; gap: 6px; }\r\n.sf2-version-flow__arrow {\r\n  width: 15px;\r\n  height: 15px;\r\n  color: var(--amber-600, #d97706);\r\n  animation: sf2-version-pulse 1.1s ease-in-out infinite;\r\n}\r\n\r\n@keyframes sf2-version-pulse {\r\n  0%, 100% { opacity: 1; transform: translateX(0); }\r\n  50% { opacity: 0.35; transform: translateX(3px); }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .sf2-version-flow__arrow { animation: none; }\r\n}\r\n\r\n/* Icono girando para los procesos que se siguen por polling (instalacion de\r\n   actualizaciones, por ejemplo): sin esto el usuario no sabe si algo avanza. */\r\n@keyframes sf2-spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n.sf2-spin { animation: sf2-spin 1s linear infinite; }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .sf2-spin { animation: none; }\r\n}\r\n\r\n/* Las pestañas que no se reescriben (licencia, organización, accesos…) se\r\n   envuelven en una tarjeta para que el aspecto sea consistente. Vale también\r\n   para las fichas que no marcan `sf2-pane` en cada pestaña. */\r\n.sf2-pane > .dv-section,\r\n.sf2-scroll > .dv-tab-pane > .dv-section {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg, 10px);\r\n  padding: 16px;\r\n}\r\n\r\n.sf2-pane > .dv-section + .dv-section,\r\n.sf2-scroll > .dv-tab-pane > .dv-section + .dv-section { margin-top: 16px; }\r\n\r\n@media (max-width: 560px) {\r\n  .sf2-row { align-items: flex-start; flex-direction: column; gap: 4px; }\r\n  .sf2-vol-use { width: 100%; }\r\n}\r\n\r\n/* ── Monitor «en vivo» del Resumen ───────────────────────────────────── */\r\n.sf2-live {\r\n  border-color: color-mix(in srgb, var(--accent) 45%, var(--border));\r\n  background:\r\n    linear-gradient(135deg, rgba(var(--accent-rgb), 0.07), transparent 55%),\r\n    var(--bg-card);\r\n}\r\n\r\n.sf2-live-head { gap: 10px; }\r\n\r\n.sf2-live-title {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.sf2-live-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #22c55e;\r\n  animation: sf2LivePulse 2s infinite;\r\n  flex: none;\r\n}\r\n\r\n.sf2-live-dot--idle { background: #9ca3af; animation: none; }\r\n\r\n@keyframes sf2LivePulse {\r\n  0%   { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55); }\r\n  70%  { box-shadow: 0 0 0 7px rgba(34, 197, 94, 0); }\r\n  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }\r\n}\r\n\r\n.sf2-live-when {\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n  font-weight: 500;\r\n  margin-right: auto;\r\n}\r\n\r\n.sf2-live-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 10px;\r\n}\r\n\r\n.sf2-live-metric {\r\n  background: var(--slate-100);\r\n  border-radius: 9px;\r\n  padding: 8px 10px;\r\n  min-width: 0;\r\n}\r\n\r\n.sf2-live-metric > span { font-size: 0.7rem; color: var(--text-muted); display: block; }\r\n.sf2-live-metric > b { font-size: 1.1rem; display: block; line-height: 1.2; }\r\n.sf2-live-metric small { font-size: 0.68rem; color: var(--text-muted); }\r\n.sf2-live-spark { height: 24px; margin-top: 2px; }\r\n.sf2-live-nochart { height: 24px; }\r\n\r\n/* ── Organización en rejilla de dos columnas ─────────────────────────── */\r\n.sf2-org {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 16px;\r\n  align-items: start;\r\n}\r\n\r\n.sf2-org > .dv-section {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg, 10px);\r\n  padding: 16px;\r\n  min-width: 0;\r\n}\r\n\r\n.sf2-org > .dv-section + .dv-section { margin-top: 0; }\r\n.sf2-org > .sf2-org-full { grid-column: 1 / -1; }\r\n\r\n/* Subgrupos dentro de una tarjeta (roles de Windows, features…) */\r\n.sf2-subgroup { margin-top: 12px; }\r\n.sf2-subgroup:first-of-type { margin-top: 8px; }\r\n\r\n.sf2-subtitle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin-bottom: 6px;\r\n  font-size: 0.74rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.sf2-chipset { display: flex; flex-wrap: wrap; gap: 6px; }\r\n.sf2-chipset .sf2-pill { padding: 4px 11px; font-size: 0.78rem; }\r\n\r\n/* ── Cifrado de disco (BitLocker) ──────────────────────────────────────────\r\n   Antes era un bloque suelto con estilos en línea dentro de Almacenamiento.\r\n   Ahora es una tarjeta más, con la pill de estado en la cabecera y una fila\r\n   por volumen. */\r\n.sf2-bitlocker h3 { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }\r\n\r\n.sf2-bl-vols {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.sf2-bl-vol {\r\n  display: grid;\r\n  grid-template-columns: 52px minmax(80px, 1fr) minmax(0, 1.6fr) auto;\r\n  gap: 10px;\r\n  align-items: center;\r\n  padding: 7px 10px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 9px;\r\n  background: var(--slate-50);\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.sf2-bl-vol-mount { color: var(--text-primary); font-variant-numeric: tabular-nums; }\r\n.sf2-bl-vol-status { color: var(--text-secondary); }\r\n.sf2-bl-vol-meta { color: var(--text-muted); font-size: 0.76rem; }\r\n\r\n@media (max-width: 700px) {\r\n  .sf2-bl-vol { grid-template-columns: 52px 1fr; row-gap: 4px; }\r\n  .sf2-bl-vol-meta { grid-column: 1 / -1; }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .sf2-live-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n  .sf2-org { grid-template-columns: 1fr; }\r\n  .sf2-org > .sf2-org-full { grid-column: auto; }\r\n}\r\n\r\n/* ── Cabecera de ficha en pantallas menores ────────────────────────────────\r\n   En un 14\" (o con la ventana a media pantalla) la cabecera acumulaba título,\r\n   miga, tres badges y cinco chips: robaba dos filas y el contenido empezaba\r\n   muy abajo. Aquí se recortan los badges y la miga; los chips que quedan son\r\n   contadores (discos, componentes, usuarios, Docs) y no se ocultan.\r\n\r\n   Los umbrales son los mismos que usa `useCompactViewport` (alto de 14\" y\r\n   ancho donde la cabecera ya no cabe), no solo el ancho: un 1366×768 tiene\r\n   ancho de sobra y se queda sin alto, que es el problema real. */\r\n@media (max-height: 820px), (max-width: 1100px) {\r\n  .sf2-chips { gap: 6px; padding-bottom: 0; }\r\n}\r\n\r\n@media (max-width: 1400px) {\r\n  .sf2-head .sf2-badges { flex-wrap: wrap; }\r\n  .sf2-badges .sf2-badge:nth-child(n+4) { display: none; }\r\n}\r\n\r\n@media (max-width: 1000px) {\r\n  .sf2-head .sf2-badges { display: none; }\r\n  .sf2-head .sf2-crumb { display: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
